import React from 'react';
import { Link } from 'react-router-dom';
import { useStartCheckout } from '../../hooks/useStartCheckout';

/**
 * Starts checkout via /checkout page (link mode) or direct payment redirect (button mode).
 */
export default function UpgradeButton({
  plan = 'pro',
  interval = 'monthly',
  children,
  className = 'marketing-btn marketing-btn-primary',
  kind = 'primary',
  useCheckoutPage = false,
}) {
  const { startCheckout, loading, error } = useStartCheckout();

  if (useCheckoutPage) {
    const to = `/checkout?plan=${encodeURIComponent(plan)}&interval=${encodeURIComponent(interval)}`;
    return (
      <Link to={to} className={className}>
        {children}
      </Link>
    );
  }

  const onClick = () => startCheckout({ plan, interval });

  return (
    <>
      <button type="button" className={className} onClick={onClick} disabled={loading}>
        {loading ? 'Starting checkout…' : children}
      </button>
      {error && <p style={{ color: '#c92a2a', fontSize: 13, marginTop: 8 }}>{error}</p>}
    </>
  );
}
